<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem
            (click)="onEditMetadata(metadata)"
            [disabled]="!userIsAllowedToEdit">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
    </button>

    <button ngbDropdownItem
            [ngClass]="{'text-danger': userIsAllowedToEdit}"
            [disabled]="!userIsAllowedToEdit"
            (click)="onDeleteMetadata(metadata)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span></button>
  </div>
</div>
